export default __webpack_public_path__ + "static/sidewalk-70e8ddb3d0ea51b4d110e86481be81d9.jpg";